import React from "react"
import { FormattedMessage } from "react-intl"
import Tabs from "../../common/layout/tabs.component"

const PaymentTabs = () => {

    const tabs = [
        {
            name: <FormattedMessage
                id="payment.listing.payment_tabs.payments"
                defaultMessage="Payments"
            />,
            link: "/payments/listing",
        },
    ]    

    return <>
        <Tabs value={tabs} />
    </>
}

export default PaymentTabs


// WEBPACK FOOTER //
// ./src/payment/listing/paymentTabs.tsx